$(window).on('load', event => {
  setTimeout(() => {
    $.getScript('https://platform.twitter.com/widgets.js', function(data, textStatus, jqxhr) {
      console.log(`Twitter widget API loading status: ${jqxhr.status} - ${textStatus}`);
    });
  }, 5000);
});
